import React, { PureComponent } from 'react';
import { FormGroup, Collapse } from 'reactstrap';

class UncontrolledFormGroupCollapse extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }

  render() {
    const { children, className } = this.props;
    const { isOpen } = this.state;
    return (
      <FormGroup className={className}>
        <Collapse isOpen={isOpen}>{children}</Collapse>
      </FormGroup>
    );
  }
}

export default UncontrolledFormGroupCollapse;



// WEBPACK FOOTER //
// ./src/components/form/uncontrolled-form-group-collapse.js